import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IBlogWithLeadPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  content?: string;
  background_color?: string;
  enable_padding?: boolean;
  enable_lead_form?: boolean;
  status?: boolean;
}

export async function createBlogWithLead(payload: Partial<IBlogWithLeadPayload>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.BLOG_WITH_LEAD.CREATE,
      payload,
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateBlogWithLead(
  id: number,
  payload: Partial<IBlogWithLeadPayload>,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.BLOG_WITH_LEAD.UPDATE(id),
      payload,
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
